import styled from 'styled-components'

export const Wrapper = styled.div`
  .title {
    display: flex;
    min-height: 6rem;
    align-items: center;
    margin: 0 1rem;
  }
  .cancel {
    background-color: var(--primary2);
    color: var(--primary5);
  }
`
